export default __webpack_public_path__ + "static/media/44.bfec3cc0.jpg";